export class LexisNexisQuizAnswer {
  questionId!: string;
  choiceId!: string;
}
